(function () {
  // Ensure _br_uid_2 exists before Discovery API calls.
  // Sync only — do not wait for BrTrk/GTM (keeps PLP fast).
  // Required for category personalization + A/B bucketing.
  // https://documentation.bloomreach.com/discovery/reference/cookie-_br_uid_2
  function ensureBrUid2() {
    var match = document.cookie.match(/(?:^|;)\s*_br_uid_2=([^;]*)/);
    if (match && match[1]) {
      try {
        return decodeURIComponent(match[1]);
      } catch (e) {
        return match[1];
      }
    }
    var uid =
      'uid=' +
      Math.round(Math.random() * 1e12) +
      ':v=11.5:ts=' +
      Date.now() +
      ':hc=1';
    var expires = new Date(Date.now() + 63072000000).toUTCString();
    document.cookie =
      '_br_uid_2=' +
      encodeURIComponent(uid) +
      '; expires=' +
      expires +
      '; path=/; SameSite=Lax';
    return uid;
  }

  window.ensureBrUid2 = ensureBrUid2;
  ensureBrUid2();

  var brtrk = document.createElement('script');
  brtrk.type = 'text/javascript';
  brtrk.async = true;
  brtrk.src = '//cdn.brcdn.com/v1/br-trk-7858.js';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(brtrk, s);
})();
